import * as tslib_1 from "tslib";
import Vue from 'vue';
import * as common from 'file-uploader-component';
export * from 'file-uploader-component';
import Component from 'vue-class-component';
import { indexTemplateHtml, indexTemplateHtmlStatic } from './variables';
var fileUploadedEventName = 'file-uploaded';
var FileUploader = /** @class */ (function (_super) {
    tslib_1.__extends(FileUploader, _super);
    function FileUploader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requests = [];
        return _this;
    }
    Object.defineProperty(FileUploader.prototype, "localeObject", {
        get: function () {
            return common.getLocale(this.locale);
        },
        enumerable: true,
        configurable: true
    });
    FileUploader.prototype.getProgressWidth = function (request) {
        return {
            width: request.percent + '%'
        };
    };
    FileUploader.prototype.onDrop = function (e) {
        var _this = this;
        common.onDrop(e, this.name, this.url, this.method, function (file) {
            _this.$emit('file-got', file);
        }, function (request) {
            _this.$emit(fileUploadedEventName, request.response);
            common.removeRequest(_this.requests, request);
        }, function (percent) {
            // nothing to do
        }, function (request) {
            _this.requests.push(request);
        });
    };
    FileUploader.prototype.onPaste = function (e) {
        var _this = this;
        common.onPaste(e, this.name, this.url, this.method, function (file) {
            _this.$emit('file-got', file);
        }, function (request) {
            _this.$emit(fileUploadedEventName, request.response);
            common.removeRequest(_this.requests, request);
        }, function (percent) {
            // nothing to do
        }, function (request) {
            _this.requests.push(request);
        });
    };
    FileUploader.prototype.onFileUploaded = function (e) {
        var _this = this;
        common.onFileUploaded(e, this.name, this.url, this.method, function (file) {
            _this.$emit('file-got', file);
        }, function (request) {
            _this.$emit(fileUploadedEventName, request.response);
            common.removeRequest(_this.requests, request);
        }, function (percent) {
            // nothing to do
        }, function (request) {
            _this.requests.push(request);
        });
    };
    FileUploader = tslib_1.__decorate([
        Component({
            props: ['accept', 'multiple', 'locale', 'name', 'url', 'method'],
            render: indexTemplateHtml,
            staticRenderFns: indexTemplateHtmlStatic
        })
    ], FileUploader);
    return FileUploader;
}(Vue));
export { FileUploader };
Vue.component('file-uploader', FileUploader);
